export default __webpack_public_path__ + "static/media/DailyBonus_BehindMultRayburst.939f35f4.png";